function findTargetById (vm, id) {
  return vm.runtime.targets.find(t => t.id === id)
}

function findSpriteByName (vm, name) {
  const target = vm.runtime.targets.find(t => t.sprite.name === name)
  if (target) {
    const original = target.sprite.clones[0]
    if (!original.isDestroyed) {
      return original
    }
    if (target.sprite.clones.length > 1) {
      return target.sprite.clones[1]
    } else {
      return null
    }
  }
  return null
}

module.exports = {findTargetById, findSpriteByName}
